import type { HoldPayload } from '@holdthat/core';

export interface HoldRelations {
  collectionHolds: Record<string, string[]>;
  groupHolds: Record<string, string[]>;
  annotationHolds: Record<string, string>;
}

function assignmentsByHold(assignments: Record<string, string[]>): Map<string, string[]> {
  const result = new Map<string, string[]>();
  for (const [containerID, holdIDs] of Object.entries(assignments)) {
    for (const holdID of holdIDs) {
      const values = result.get(holdID) ?? [];
      values.push(containerID);
      result.set(holdID, values);
    }
  }
  return result;
}

/**
 * Outer relations are server-authoritative because the server enforces group
 * membership and visibility without reading the encrypted Hold payload.
 * Locally pending entities retain their decrypted assignments until accepted.
 */
export function applyAuthoritativeHoldRelations(
  holds: HoldPayload[],
  relations: HoldRelations,
  pendingEntityIDs: ReadonlySet<string>,
): HoldPayload[] {
  const collections = assignmentsByHold(relations.collectionHolds);
  const groups = assignmentsByHold(relations.groupHolds);

  return holds.map((hold) => pendingEntityIDs.has(hold.id) ? hold : {
    ...hold,
    collectionIDs: collections.get(hold.id) ?? [],
    groupIDs: groups.get(hold.id) ?? [],
  });
}
